import CategoriesPage from './views/categories.page';
import EditCategory from './views/editCategory';

export default {
  views: {
    CategoriesPage,
    EditCategory
  },
};
